<template>
    <section id="today" class="container">
        <div class="container mt-3" >
            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartIncomeProjection v-if="loaded" :filters="filters" :triggerSearch="triggerSearch"></ChartIncomeProjection>
                </b-card>
            </b-card-group>
            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartRevenues v-if="loaded" :filters="filters" :triggerSearch="triggerSearch"></ChartRevenues>
                </b-card>
                <b-card border-variant="success" align="center">
                    <ChartRevenueGrowth v-if="loaded" :filters="filters" :triggerSearch="triggerSearch"></ChartRevenueGrowth>
                </b-card>
            </b-card-group>
            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartCompletionRate v-if="loaded" :filters="filters" :triggerSearch="triggerSearch"></ChartCompletionRate>
                </b-card>
                <b-card border-variant="success" align="center">
                    <ChartRidesGrowth v-if="loaded" :filters="filters" :triggerSearch="triggerSearch"></ChartRidesGrowth>
                </b-card>
            </b-card-group>

        </div>
    </section>
</template>

<script>
    //import api from '../../../../api.js'
    import ChartRevenues from '../charts/admin/Revenues'
    import ChartRevenueGrowth from '../charts/admin/RevenueGrowth'
    import ChartCompletionRate from '../charts/admin/CompletionRate'
    import ChartRidesGrowth from '../charts/admin/RidesGrowth'
    import ChartIncomeProjection from '../charts/admin/IncomeMoneyProjection'
    export default {
        name: "Admin",
        components:{ChartRevenues,ChartRevenueGrowth,ChartCompletionRate,ChartRidesGrowth,ChartIncomeProjection},
        props:{
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            return {
                loaded: false
            }
        },
        methods:{

        },
        mounted(){
            this.loaded=true;
        },
        watch:{

        }
    }
</script>

<style scoped>

</style>